import { useState } from "react"
import { FormError, FormLabel, InputLista, Modal } from "../../../common"
import { useFormErrors } from "../../../hooks"
import { openTempView } from "../../../../utils/openTempView"
import { APPCONFIG } from "../../../../app.config"
import { ALERT_TYPE, ShowToastMessage, TIPO_TRIBUTO_URLS } from '@laramie/ui';
import {TIPS} from "../../../../consts/tips";
import { VALIDATION_MESSAGE } from "../../../../consts/validationMessage";

export const SelectTipoTributoModal = ({ show, close }) => {
    const [value, setValue] = useState(0)

    const getErrors = () => {
        const errors = {}
        if (!TIPO_TRIBUTO_URLS[value]) errors.idTipoTributo = VALIDATION_MESSAGE.REQUIRED_OPTION
        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors)

    const onAccept = () => {
        if (!validate()) return

        close()
        openTempView(`${APPCONFIG.SITE.WEBAPP}${TIPO_TRIBUTO_URLS[value]}/new`)
    }

    return (
        <Modal
            onEscape={close}
            show={show}
            title='Selección de tipo de tributo'
            tipName={TIPS.NAME.MODALS.SELECCION_TIPO_TRIBUTO_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12">
                        <FormLabel htmlFor="idTipoTributo" required>Tipo de tributo</FormLabel>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoTributo') ? 'is-invalid' : ''}`}
                            value={value}
                            onChange={({ target }) => setValue(target.value)}
                            lista="TipoTributo"
                        />
                        <FormError message={errorOf('idTipoTributo')} />
                    </div>
                </div>
            )}
            footer={<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={close}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
            </>}
        />
    )
}